/**
 * EventCancelDialog - A component that renders a form with a text field for entering
 * the reason for cancelling an event. The component uses formik for form management.
 *
 * @component
 * @param {Object} props - The component props
 * @param {Object} props.formik - The formik instance to handle form state and validation
 * @returns {JSX.Element} A form with a multiline text field for entering cancellation reason
 */

import React from 'react';
import { TextField } from '@mui/material';

function EventCancelDialog({ formik }) {
    return (
        <React.Fragment>
            <form onSubmit={formik.handleSubmit}>
                <div style={styles.eventCancelltionContainer}>
                    <TextField
                        rows={4}
                        multiline
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true
                            }
                        }}
                        id="event-cancel-reason"
                        label="Reason for cancellation"
                        placeholder="Please provide a reason for cancellation"
                        value={formik.values.reason}
                        onChange={(e) => formik.setFieldValue('reason', e.target.value)}
                        onBlur={formik.handleBlur}
                        error={formik.touched.reason && Boolean(formik.errors.reason)}
                        helperText={formik.touched.reason && formik.errors.reason}
                    />
                </div>
            </form>
        </React.Fragment>
    );
}

export default EventCancelDialog;

const styles = {
    eventCancelltionContainer: {
        width: '100%',
        height: '167px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
    }
};
